function toMapCoord(value: number | string | undefined) {
  if (value == null || value === '') {
    return ''
  }

  return String(value).replace(',', '.')
}

/**
 * URL статической карты Яндекса для превью адреса клиники.
 */
export default function getYandexStaticMapUrl(lat?: number | string, lon?: number | string) {
  const latitude = toMapCoord(lat)
  const longitude = toMapCoord(lon)

  if (!latitude || !longitude) {
    return ''
  }

  return `https://static-maps.yandex.ru/1.x/?ll=${longitude},${latitude}&pt=${longitude},${latitude},pm2rdm&size=378,235&z=13&l=map`
}
